import { createFileRoute } from "@tanstack/react-router";
import AcceleratedTmsCoverage from "@/pages/AcceleratedTmsCoverage";
export const Route = createFileRoute("/accelerated-tms-coverage")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Insurance Coverage for Accelerated TMS & SAINT® | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Does insurance cover accelerated TMS and SAINT? Learn how commercial plans, Medicare, and prior auth work. Free benefits verification in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Insurance Coverage for Accelerated TMS & SAINT® | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Does insurance cover accelerated TMS and SAINT? Learn how commercial plans, Medicare, and prior auth work. Free benefits verification in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/accelerated-tms-coverage",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/accelerated-tms-coverage",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AcceleratedTmsCoverage />;
}
